<!-- 流量变现 -->
<template>
    <div class="advantage_wrapper">
        <!-- part1 -->
        <div class="section_item advantage_section1 platform_section1">
            <div class="wrapper">
                <div class="block">
                    <div class="title">{{section1.title}}</div>
                    <div class="subtitle">{{section1.subtitle}}</div>
                    <div class="description">{{section1.description}}</div>
                    <el-button @click="bind_toggle_form('cooperation')" type="warning" class="btn_init">{{section1.cta}}</el-button>    
                </div> 
                <img :src="section1.link" alt="">
            </div>
        </div>
         <!-- part2 -->
        <div class="section_item advantage_section2 platform_image_text">
            <div v-for="(item, idx) in section2.data || []"
                :key="idx"
                class="show_wrapper">
                <div class="show_content">
                    <div class="title_en">{{item.title_en}}</div>
                    <div class="title">{{item.title}}</div>
                    <div class="underline"></div>
                    <div class="description">{{item.description}}</div>
                </div>
                <div
                    :style="{float: item.pos}" 
                    class="show_img"><img :src="item.link" alt=""></div>
            </div>
        </div>
        <div class="section_item advantage_section3">
            <div class="form_wrapper">
                <CmsForm/>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/flow.js';
    export default {
        name: "FlowToCash",
        components: {
            CmsForm,
            BottomMsg
        },
        computed: {
            section1() {
                return data && data.section1;
            },
            section2() {
                return data && data.section2;
            }
        },
        mounted() {
            // 百度统计

        },
        methods: {
            // 显示合作/登录组件
            bind_toggle_form(flag) {
                // 百度统计
                window._hmt.push(['_trackEvent', 'ctaTrigger', 'traffic', flag]);
                this.$emit('toggleForm', flag);
            }
        }
    }
</script>

<style scoped>
    /* 整个首页的包裹样式 */
    .advantage_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
    }
    /* 第一部分的样式 */
    .advantage_section1 {
        background: linear-gradient(0deg, #f5f9ff 0%, #fcfdff 100%);
        background: #fcfdff\9\0;
    }
     /* 第二部分的样式 */
    .advantage_section2 {
        background: #fff;
    }
     /* 第五部分的样式 */
    .advantage_section3 {
        background: #FAFCFF;
        height: auto;
    }
    /* 标题包裹狂 */
    .advantage_section3 .form_wrapper {
        width: 1280px;
        margin: 0 auto;
        margin-top: 48px;
        margin-bottom: 54px;
    }

</style>





// WEBPACK FOOTER //
// src/containers/Flow/FlowToCash.vue